import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react";
import { MetadataMode } from "datasets/pages/tables/types/enums/metadata";

interface MetadataContextType {
  mode: MetadataMode | undefined;
  setMode: Dispatch<SetStateAction<MetadataMode | undefined>>;
  errors: string[];
  setErrors: Dispatch<SetStateAction<string[]>>;
}

const MetadataContext = createContext<MetadataContextType | undefined>(undefined);

export const MetadataProvider = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<MetadataMode | undefined>();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <MetadataContext.Provider value={{ mode, setMode, errors, setErrors }}>
      {children}
    </MetadataContext.Provider>
  );
};

const useMetadataContext = (): MetadataContextType => {
  const context = useContext(MetadataContext);

  if (!context) {
    throw new Error("useMetadataContext must be used within a MetadataProvider");
  }

  return context;
};

export default useMetadataContext;
